import { Divider } from "@/components/ui/divider";
import { Text } from "@/components/ui/text";
import i18n from 'i18n-js';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ModalBase from './ModalBase';
import { FlatList } from 'react-native-gesture-handler';
import ContactElement from '@/components/basic/ContactElement';
import { backendRequest } from '@/stores/thunks';

export default function ModalSendCopy({ flowId, showModal, setShowModal }) {

    const contacts = useSelector((state) => state.contacts)
    const dispatch = useDispatch()

    const [actContacts, setActContacts] = useState([])
    const [actChannels, setActChannels] = useState([])
    const [channelContacts, setChannelContacts] = useState(contacts.channels.filter(channel => actChannels.includes(channel.id)).map(channel => channel.contacts).flat() || [])

    const setContacts = (contactId, isSelected) => {
        // since isSelected reflects a combination of contact and channels state we need check contacts directly
        if (!actContacts.includes(contactId)) {
            setActContacts(prev => {
                const next = [...prev]
                next.push(contactId)
                return next
            })
        } else {
            setActContacts(prev => {
                const next = prev.filter(id => id != contactId)
                return next
            })
        }
    }

    const setChannels = (channelId, isSelected) => {
        if (isSelected) {
            setActChannels(prev => {
                const next = [...prev]
                next.push(channelId)
                setChannelContacts(contacts.channels.filter(channel => next.includes(channel.id)).map(channel => channel.contacts).flat())
                return next
            })
        } else {
            setActChannels(prev => {
                const next = prev.filter(id => id != channelId)
                setChannelContacts(contacts.channels.filter(channel => next.includes(channel.id)).map(channel => channel.contacts).flat())
                return next
            })
        }
    }

    const onClose = (isOk) => {
        const users = actContacts.map(contactId => contacts.active.find(contact => contact.id == contactId).toUser.id).concat(channelContacts.filter(contactId => !actContacts.includes(contactId)).map(contactId => contacts.active.find(contact => contact.id == contactId).toUser.id))
        if (isOk && users.length > 0) {
            console.log('SEND', users)
            dispatch(backendRequest('STUDIO_SEND_WF', '/studio/workflow/' + flowId + '/send', {
                users: users
            }, 'POST', false)).then(result => console.log(result))
        }
        setShowModal(false)
    }

    const renderItem = ({ item, index }) => {
        return (item.info ? <>
            {item.div && <Divider className="mt-2" />}
            <Text className="font-[400] px-3 py-3 text-2xl text-secondary-900">{item.info}</Text>
        </> : item.toUser ?
            <ContactElement
                key={'A' + index}
                uri={item?.contactImage?.id || item.toUser.id}
                title={item.contactAlias || item.toUser.mail} text={item.toUser.preferredName}
                onPress={setContacts}
                id={item.id}
                selected={actContacts.includes(item.id)}
                selected2={channelContacts.includes(item.id)} />
            :
            <ContactElement
                key={'B' + index}
                uri={item?.channelImage?.id}
                title={item.name}
                text={i18n.t('channel.numcontacts', { num: item.contacts.length })}
                onPress={setChannels}
                id={item.id}
                selected={actChannels.includes(item.id)} />);
    }

    const getData = () => {
        const showContacts = contacts.active
        const showChannels = contacts.channels
        return [{ info: i18n.t('contactManagement.contacts', { num: showContacts.length }) }, ...showContacts, { info: i18n.t('contactManagement.channels', { num: showChannels.length }), div: true }, ...showChannels]
    }

    return (
        <ModalBase showModal={showModal} setShowModal={onClose} title={'workflowsScreen.copyTitle'} info={'workflowsScreen.copyInfo'} onButton={onClose} buttonR={'workflowsScreen.copy'} buttonL={'workflowsScreen.cancel'}>
            <FlatList
                contentContainerStyle={{ paddingBottom: 70 }}
                data={getData()}
                renderItem={renderItem}
                keyExtractor={(item, index) => (item.id || 'T') + index}
            />
        </ModalBase>
    );
}